/* eslint-disable max-len */

import LrcQuestion from 'images/coin-pages/questions/loopring.svg'

import { ICoinPageData } from '../types'

export const lrcPage: ICoinPageData = {
  title: 'coin_620',
  description: 'coin_621',
  // description: 'coin_622',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Loopring (LRC)' }) }}
    />
  ),
  questionsBlock: {
    image: LrcQuestion,
    questions: [
      {
        title: 'coin_623',
        answer: 'coin_624',
      },
      {
        title: 'coin_625',
        answer: 'coin_626',
      },
      {
        title: 'coin_627',
        answer: 'coin_628',
      },
      {
        title: 'coin_629',
        answer: 'coin_630',
      },
    ],
  },
  whatIs: {
    slides: '',
    text: ['coin_633'],
    paragraphs: [
      {
        title: 'coin_631',
        text: ['coin_634'],
      },
      {
        title: 'coin_632',
        text: ['coin_635'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-and-how-does-it-work/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'Loopring (LRC) review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'Loopring (LRC) review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/guide-to-short-selling-with-coinrabbit-bear-market-loans/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/06/Bear-loans.png',
        imageAlt: 'Loopring (LRC) review 7',
      },
    ],
  },
}
